import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  source: string;
}
@Component({
  selector: 'app-modal-conditions-and-terms',
  templateUrl: './modal-conditions-and-terms.component.html',
  styleUrls: ['./modal-conditions-and-terms.component.css'],
})
export class ModalConditionsAndTermsComponent {
  source: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.source = data.source;
  }
}
